import { buttonMessages } from "@dashboard/intl";
import { Box, Button, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { sectionMessages } from "../messages";

/**
 * Where a vocabulary list would be when it failed to load: a sentence and a
 * retry, instead of a skeleton that never resolves.
 */
export const WsmFitmentLoadError = ({ onRetry }: { onRetry: () => void }) => {
  const intl = useIntl();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      padding={6}
      data-test-id="wsm-fitment-load-error"
    >
      <Text color="critical1">{intl.formatMessage(sectionMessages.loadError)}</Text>
      <Button variant="secondary" onClick={onRetry} data-test-id="wsm-fitment-load-retry">
        {intl.formatMessage(buttonMessages.retry)}
      </Button>
    </Box>
  );
};

export default WsmFitmentLoadError;
